export default "__VITE_ASSET__CJC5fpeb__"